<section
  [ngClass]="{
    'empty-favorites-container': true,
    'is-app-panel': isAppPanel(),
  }"
>
  <img
    [src]="'/pia/assets/document_information.png'"
    [alt]="'pia.shared.emptyFavoritesAltDescription' | translate"
    class="banner-image"
  />
  <ng-content />
</section>
